import React from "react";
import {
  FixedWidth,
  PagesHeading
} from "../../../../CommonComponents/commonStyles";
import { StepFlexRow } from "../../../../CommonComponents/commonStyles";
import { ExchangeContainer, UnderlyingContent, TextWrapper, StepFlexRowExg } from "./style";
import { Col, Row, Tooltip } from "antd";
import ExchangeSelect from "./Component/ExchangeSelect/ExchangeSelect";
import PageSummary from "../../../../CommonComponents/PageSummary/PageSummary";
import PageAccountSummary from "../../../../CommonComponents/PageSummary/PageAccountSummary/PageAccountSummary";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { withRouter } from "react-router-dom";
import { fetchExchangeActivity, setTab } from "./actions";
import { connect } from "react-redux";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import { replaceAnchorWithLink } from "../../../../utils/commonUtil";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import Contents, {
  ContentProvider,
  ContentMessage,
  Types
} from "../../../../CommonComponents/ContentMessages";
import { PropTypes } from 'prop-types';
import { ExchangeActivityDerivedStates } from "./selectors";
import PendingAlerts from "../../../AccountSummary/Pages/Component/PendingAlerts/PendingAlerts";

const breadcrumbRoutes = () => {
  return [
    {
      routeName: "Home",
      path: "/#"
    },
    {
      routeName: "Investments",
      path: "/investments"
    },
    {
      routeName: "Exchange Activity",
      path: "/investments/exchange-activity"
    }
  ];
};
class ViewInvestmentExchangeActivity extends React.Component {
  constructor(props) {
    super(props);
    this.Apicalls = this.Apicalls.bind(this);
    this.state = {
      cancelCount: 0
    };
    this.pageName = "Exchange Activity";
  }

  componentDidMount() {
    this.Apicalls();
    window.scrollTo(0, 0);

    window.addEventListener("resize", e => {
      if (e.currentTarget.innerWidth <= 1024) {
        this.Apicalls();
      }
    });
  }
  Apicalls() {
    this.props.requestData({
      metaData: [
        {
          method: "GET",
          url: `/donor-portal/api/exchange/${
            getPrimaryAccount().userId
          }/findSingleExchangesByAccountId`,
          page: "exchangeActivity"
        },
        {
          method: "GET",
          url: `/donor-portal/api/exchange/${
            getPrimaryAccount().userId
          }/findRecurringExchangesByAccountId`,
          page: "exchangeActivity"
        }
      ]
    });
  }
  componentWillReceiveProps(np) {
    if (np.cancelSingle !== this.props.cancelSingle) {
      this.setState({
        cancelCount: this.props.cancelSingle
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.cancelSingle !== prevProps.cancelSingle) {
      this.Apicalls();
      window.scrollTo(0, 0);
    }
  }

  renderFundSummary(obj) {
    return (
      <PageAccountSummary
        key={obj.key}
        label={obj.label}
        value={obj.value}
        dataName={obj.key}
      />
    );
  }

  fundSummaryConfiguration(userData) {
    return [
      this.renderFundSummary({
        key: "accountName",
        label:
          this.props.singleExchanges &&
          this.props.singleExchanges.singleExchange.fundName,
        value: userData.accountNumber
      })
    ];
  }

  render() {
    if (this.props.isLoadingSingle)
      return (
        <div>
          <Preloader />
        </div>
      );

    return (
      <ExchangeContainer>
        <ContentProvider
          types={[Types.PAGE_TITLE_DESCRIPTION]}
          pages={["Exchange Activity"]}
        >
          <FixedWidth>
            <BreadcrumbComponent breadcrumbRoutes={breadcrumbRoutes()} />
            <PagesHeading>
              <ContentMessage
                type={[Types.PAGE_TITLE_DESCRIPTION]}
                page="Exchange Activity"
                property="field_page_title"
                defaultMessage="Exchange Activity"
              />
            </PagesHeading>

            {JSON.parse(sessionStorage.getItem("primaryAccount")) ? (
              <PageSummary
                fundSummaryConfig={this.fundSummaryConfiguration(
                  JSON.parse(sessionStorage.getItem("primaryAccount"))
                )}
              />
            ) : (
              <div />
            )}

            <Row>
              <Col
                className="exchange-activity-heading"
                lg={18}
                md={18}
                xs={24}
              >
                <TextWrapper>
                  <Contents.Consumer>
                    {props => {
                      if (
                        props.page_title_description &&
                        props.page_title_description["Exchange Activity"]
                      ) {
                        let PageData = replaceAnchorWithLink(
                          props.page_title_description["Exchange Activity"]
                            .description__value,
                          "tooltipAnchor",
                          props.page_title_description["Exchange Activity"]
                            .field_link_tooltip
                        );
                        return PageData.map(data => {
                          if (typeof data === "string") {
                            return (
                              <span
                                dangerouslySetInnerHTML={{ __html: data }}
                              ></span>
                            );
                          } else {
                            return data;
                          }
                        });
                      }
                    }}
                  </Contents.Consumer>
                </TextWrapper>
              </Col>
            </Row>
            { !this.props.isLoadingSingle && this.props.singleExchanges.accountBannerFlag && <Row className="mt-40">
             <PendingAlerts
              account_data = {this.props.singleExchanges.accountBannerFlag}
              pageName = { "EA" }
            />
            </Row>
            }
            <StepFlexRowExg>
              <Col
                lg={{ span: 24 }}
                className="tableHeightWithScroll alignSortIcon overflowForIE"
              >
                {!this.props.singleExchanges.singleExchange &&
                !this.props.recurringExchanges.recurringExchanges ? (
                  <Preloader />
                ) : (
                  <ExchangeSelect
                    singleExchanges={
                      this.props.singleExchanges &&
                      this.props.singleExchanges.singleExchange
                    }
                    recurringExchanges={
                      this.props.recurringExchanges &&
                      this.props.recurringExchanges.recurringExchanges
                    }
                    user={JSON.parse(sessionStorage.getItem("primaryAccount"))}
                    cancel={this.props.cancelSingle}
                    page={this.pageName}
                  />
                )}
              </Col>
            </StepFlexRowExg>
          </FixedWidth>
        </ContentProvider>
      </ExchangeContainer>
    );
  }
}

export const mapStateToProps = state => {
  return {
    ...ExchangeActivityDerivedStates(state.toJS()),
  };
};


export const mapDispatchToProps = dispatch => ({
  requestData: data => dispatch(fetchExchangeActivity(data)),
  setTab: data => dispatch(setTab(data))
});
ViewInvestmentExchangeActivity.propTypes = {
  isLoadingRecurring:PropTypes.bool,
  recurringExchanges:PropTypes.object,
  singleExchanges:PropTypes.object,
  cancelSingle: PropTypes.number,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ViewInvestmentExchangeActivity)
);
